import React from 'react';
import { Box, Typography } from '@mui/material';
import { People } from '@mui/icons-material';
import ClientsList from '../crm/components/ClientsList';

const Klienci = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <People color="primary" sx={{ fontSize: 32 }} />
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Klienci
          </Typography>
          <Typography variant="body2" color="text.secondary">
            CRM — zarządzaj relacjami z klientami
          </Typography>
        </Box>
      </Box>

      <ClientsList />
    </Box>
  );
};

export default Klienci;
